const Plus = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_473_9592)">
        <path
          d="M7.99902 0.996094C8.41314 0.996094 8.74887 1.33201 8.74902 1.74609V7.25098H14.2539C14.668 7.25114 15.0039 7.58687 15.0039 8.00098C15.0035 8.41474 14.6677 8.75081 14.2539 8.75098H8.74902V14.2539L8.74512 14.3301C8.70679 14.7083 8.3874 15.0039 7.99902 15.0039C7.61085 15.0037 7.29122 14.7082 7.25293 14.3301L7.24902 14.2539V8.75098H1.74609L1.66992 8.74707C1.29186 8.70879 0.996474 8.38904 0.996094 8.00098C0.996094 7.6126 1.29165 7.29321 1.66992 7.25488L1.74609 7.25098H7.24902V1.74609C7.24918 1.33218 7.58514 0.996364 7.99902 0.996094Z"
          fill="#1A1919"
        />
      </g>
      <defs>
        <clipPath id="clip0_473_9592">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Plus;
